import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Shield } from 'lucide-react';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 rounded-full border border-white/10 mb-6">
              <Shield className="w-4 h-4 text-emerald-400" />
              <span className="text-white/60 text-sm">Legal</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white" data-testid="disclaimer-heading">Disclaimer</h1>
          </div>

          <div className="bg-white/5 rounded-2xl border border-white/10 p-8 lg:p-12" data-testid="disclaimer-content">
            <p className="text-white/70 text-base leading-relaxed mb-6" data-testid="disclaimer-registration">
              Frontier Investments is not a SEBI registered entity. We are AMFI certified Mutual Fund Distributors (ARN-92591).
            </p>
            <p className="text-white/70 text-base leading-relaxed">
              Mutual Fund investments and all Capital Market Instruments are subject to market risks, read all scheme related documents carefully. The NAVs of the schemes may go up or down depending upon the factors and forces affecting the securities market including the fluctuations in the interest rates. The past performance of the mutual funds is not necessarily indicative of future performance of the schemes. The Mutual Fund is not guaranteeing or assuring any dividend under any of the schemes and the same is subject to the availability and adequacy of distributable surplus. Investors are requested to review the prospectus carefully and obtain expert professional advice with regard to specific legal, tax and financial implications of the investment/participation in the scheme. The information, tools and calculators on the website are only meant for information purpose only; investors and visitors to the website must not use these tools and calculators for Investments purpose and must consult their Advisors or seek Expert Professional Advice for more clarity &amp; guidance.
            </p>
          </div>

          <div className="mt-8 flex items-center justify-center gap-4 text-white/40 text-xs">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/5 rounded-full">
              <Shield className="w-4 h-4 text-emerald-500" />
              <span>AMFI Certified MFD</span>
            </div>
            <span>ARN-92591</span>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
